
import ScrMbc0116 from '~/pages/mb/mbc/SCR_MBC_0116.vue' // 환불계좌등록 팝업
import ScrMbc011501 from '~/pages/mb/mbc/SCR_MBC_0115_01.vue' // 배송지/픽업매장관리 팝업

export default {
  name: 'Lnb',
  components: {
    ScrMbc0116,
    ScrMbc011501
  },
  props: {
    active: { // index(활성화)
      type: String,
      default: '0-0'
    }
  },
  data () {
    return {
      menuData: [ // lnb 메뉴 data
        {
          id: '0',
          title: '주문관리',
          subTit: [
            {
              id: '0',
              tit: '주문 내역',
              linkUrl: '/or/ORB/SCR_ORB_0001',
              popupYn: 'N'
            },
            {
              id: '1',
              tit: '취소/교환/반품 내역',
              linkUrl: '/or/ORB/SCR_ORB_0018',
              popupYn: 'N'
            },
            {
              id: '2',
              tit: '정기배송 관리',
              linkUrl: '/fb/FBB/SCR_FBB_0001',
              popupYn: 'N'
            }
            // ,
            // {
            //   id: '3',
            //   tit: '대량구매 관리'
            // }
          ]
        },
        {
          id: '1',
          title: '나의 활동 관리',
          subTit: [
            {
              id: '0',
              tit: '나의 리뷰 관리',
              linkUrl: '/pd/pdt/SCR_PDT_0001',
              popupYn: 'N'
            },
            {
              id: '1',
              tit: '오늘의 발견 관리',
              linkUrl: '/ug/ugp/SCR_UGP_0003',
              popupYn: 'N'
            },
            {
              id: '2',
              tit: '최근 본 상품',
              linkUrl: '/pd/pdt/SCR_PDT_0004',
              popupYn: 'N'
            },
            {
              id: '3',
              tit: '자주 산 상품',
              linkUrl: '/or/ORB/SCR_ORB_0037',
              popupYn: 'N'
            },
            {
              id: '4',
              tit: '찜한 상품',
              linkUrl: '/pd/pdt/SCR_PDT_0003',
              popupYn: 'N'
            },
            {
              id: '5',
              tit: '스크랩한 콘텐츠',
              linkUrl: '/ug/ugm/SCR_UGM_0002',
              popupYn: 'N'
            },
            {
              id: '6',
              tit: '이벤트 참여 내역',
              linkUrl: '/ev/evd/SCR_EVD_0009',
              popupYn: 'N'
            },
            {
              id: '7',
              tit: '스탬프 미션',
              linkUrl: '/ev/evd/SCR_EVD_0011',
              popupYn: 'N'
            }
          ]
        },
        {
          id: '2',
          title: '혜택 및 결제수단 관리',
          subTit: [
            {
              id: '0',
              tit: '환불계좌 관리',
              linkUrl: '/mb/mbc/SCR_MBC_0116',
              popupYn: 'Y',
              name: 'refund'
            },
            {
              id: '1',
              tit: '다이소 포인트',
              linkUrl: '/ms/mse/SCR_MSE_0001',
              popupYn: 'N'
            },
            {
              id: '2',
              tit: '다이소몰 포인트',
              linkUrl: '/ms/mse/SCR_MSE_0002',
              popupYn: 'N'
            },
            {
              id: '3',
              tit: '쿠폰',
              linkUrl: '/ev/evd/SCR_EVD_0001',
              popupYn: 'N'
            },
            {
              id: '4',
              tit: '상품권 관리',
              linkUrl: '/py/pya/SCR_PYA_0002',
              popupYn: 'N'
            }
          ]
        },
        {
          id: '3',
          title: '나의 정보 관리',
          subTit: [
            {
              id: '0',
              tit: '배송지/픽업매장 관리',
              linkUrl: '/mb/mbc/SCR_MBC_0115_01',
              popupYn: 'Y',
              name: 'pkUp'
            },
            {
              id: '1',
              tit: '회원정보 설정',
              linkUrl: '/mb/mbc/SCR_MBC_0112',
              popupYn: 'N'
            },
            {
              id: '2',
              tit: '알림 목록',
              linkUrl: '/ug/ugp/SCR_UGP_0020',
              popupYn: 'N'
            },
            // ,
            // {
            //   id: '3',
            //   tit: '약관조회',
            //   linkUrl: ''
            // }
            {
              id: '3',
              tit: '프로필 관리',
              linkUrl: '/ug/ugp/SCR_UGP_0018',
              popupYn: 'N'
            },
            {
              id: '4',
              tit: '재입고/판매시작 알림',
              linkUrl: '/pd/pdm/SCR_PDM_0002',
              popupYn: 'N'
            }
          ]
        },
        {
          id: '4',
          title: '고객센터',
          subTit: [
            {
              id: '0',
              tit: '홈',
              linkUrl: '/cs/csh/SCR_CSH_0000',
              popupYn: 'N'
            },
            {
              id: '1',
              tit: 'FAQ',
              linkUrl: '/cs/csi/SCR_CSI_0001',
              popupYn: 'N'
            },
            {
              id: '2',
              tit: '문의내역',
              linkUrl: '/cs/csk/SCR_CSK_0000',
              popupYn: 'N'
            },
            {
              id: '3',
              tit: '문의하기',
              linkUrl: '/cs/csl/SCR_CSL_0001',
              popupYn: 'N'
            },
            {
              id: '4',
              tit: '공지사항',
              linkUrl: '/cs/csm/SCR_CSM_0000',
              popupYn: 'N'
            }
          ],
          linkUrl: '/cs/csh/SCR_CSH_0000'
        }
      ],
      crwTrmAgrYn: '',
      crwUrl: ''
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  mounted () {
    // 전체 아코디언 활성화
    this.$refs.menu.$el.querySelectorAll('.el-submenu').forEach((item, idx) => {
      if (item.classList.contains('.is-active.is-opened') !== true) {
        this.$refs.menu.open(idx)
      }
    })
    // 다이버 여부에 따른 메뉴 활성화
    if (this.$store.getters['session/getCrwYn'] === 'Y') {
      const data = {
        id: '7',
        tit: '다이버 활동 관리',
        linkUrl: '',
        crwMenu: true,
        crwTrmAgrYn: this.crwTrmAgrYn,
        popupYn: 'N'
      }
      this.menuData[1].subTit.push(data)
    }
    // 회원정보 설정 URL 설정
    const userTy = this.$store.getters['session/getUserTy']
    let linkUrl = ''
    if (userTy === '21') {
      linkUrl = '/mb/mbc/SCR_MBC_0111B'
    } else if (userTy === '40') {
      linkUrl = '/mb/mbc/SCR_MBC_0111D_01'
    } else {
      linkUrl = '/mb/mbc/SCR_MBC_0111A'
    }
    this.menuData[3].subTit[1].linkUrl = linkUrl
  },
  unmounted () {
  },
  methods: {
    openPickupPopup () {
      this.goToUrl(this.menuData[3].subTit[0])
    },
    goToUrl (subItem, tabNumber = 1) {
      // console.log('[LnBCmp] >>> goToUrl')
      // console.log('[LnBCmp] >>> goToUrl >>> subItem.name', subItem.name)
      // 팝업 분기처리
      if (subItem.popupYn === 'Y') {
        this.openLayer(subItem.name, tabNumber)
      } else if (subItem.crwMenu === true) {
        this.selCrwTrmAgrYn(subItem)
      } else {
        // 페이지 이동일 경우
        this.$router.push({
          path: subItem.linkUrl
        })
      }
    },
    linkYn (item) { // 메뉴-고객센터일 경우
      if (item.id === '4') {
        this.$router.push({ path: item.linkUrl })
      }
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },
    // openLayer (name) {
    //   console.log('[LnbCmp] >>> openLayer')
    //   this.$emit('openLayer', name)
    // },
    openLayer (layer, tabNumber) {
      switch (layer) {
        case 'refund': // 환불계좌관리
          this.$refs.mbc0116.outerVisible = true
          break
        case 'pkUp': // 배송지/픽업매장관리
          this.$refs.mbc011501.outerVisible = true
          this.$refs.mbc011501.tabIdx = this.$route.query.tab ?? '1'
          this.$router.replace({ query: null })
          break
      }
    },
    selCrwTrmAgrYn (subItem) { // 다이버 활동 관리 메뉴 클릭시 동작
      this.$AxiosBuilder
        .data()
        .build()
        .post('/ug/ugp/selCrwTrmAgrYn')
        .then((res) => {
          const rsltCrwTrmAgrYn = res.data.message
          if (rsltCrwTrmAgrYn === 'Y') {
            this.menuData[1].subTit[7].linkUrl = '/ug/ugp/SCR_UGP_0007'
          } else {
            this.menuData[1].subTit[7].linkUrl = '/ug/ugp/SCR_UGP_0019'
          }
          this.$router.push({
            path: subItem.linkUrl
          })
        })
    }
  }
}
